import type { DataContainer } from "@otto-ec/tracking-bct";
import type { QBus } from "@otto-ec/global-resources/event-q-bus";
import type { DresonRuleResolvedEvent } from "./DresonRuleResolvedEvent";
import type { TeaserClient } from "./TeaserClient";
import { createLogger } from "utils/logging";
import { addLoadedTracking, addMiniActionsToVisibilityChanges } from "../utils";
import type { Debug } from "@otto-ec/global-resources/debug";

const log = createLogger("context", "teaser");
const PARENT_ID = "FT9-benefit-cinema-bottom";

export class Teaser {
	constructor(
		private readonly teaserClient: TeaserClient,
		private readonly eventQBus: QBus,
	) {}

	init(container: HTMLElement) {
		const initialized = container.dataset.initialized;
		if (initialized && initialized === "true") {
			return;
		}
		container.setAttribute("data-initialized", "true");

		const psr = container.dataset.dreson;
		if (psr) {
			this.retrieveBenefit(psr, container);
		}

		/*                                                                             */
		this.eventQBus.on("ftfind.dresonRule.resolved", (event?: DresonRuleResolvedEvent) => {
			const newPsr = event?.rule;
			if (!newPsr) {
				return;
			}
			container.innerHTML = "";

			/*                                              */
			/*                                                                                         */
			/*                                                                                                     */
			setTimeout(() => {
				this.retrieveBenefit(newPsr, container);
			}, 2_000);
		});

		/*                                                                    */
		if (document.querySelector('[data-testid="ft9_teaser_test"]')) {
			this.initTracking(container);
		}
	}

	retrieveBenefit(psr: string, container: HTMLElement) {
		const url = "/benefit-cinema/teaser/productlist";
		const params = new URLSearchParams();
		params.append("dreson", psr);

		const topCinema = document.querySelector(".ft9_benefit_cinema__context_cinema--productlist > oc-cinema-v1");
		if (topCinema) {
			const slidesInTopCinema = Array.from(topCinema.getElementsByClassName("ft9-benefit-paper-card"));
			for (const benefitSlide of slidesInTopCinema) {
				if (benefitSlide instanceof HTMLElement) {
					const benefitId = benefitSlide.dataset.benefitId;
					if (benefitId) {
						params.append("benefitIdsInCinema", benefitId);
					}
				}
			}
		}

		log.info("url to request teaser benefit teaser %s", url);

		this.teaserClient
			.get(`${url}?${params.toString()}`)
			.then((response) => {
				log.debug("successfully retrieved teaser benefit %s", response);
				container.innerHTML = response;

				this.initTracking(container);
			})
			.catch((reason) => {
				log.warn("Error when requesting teaser benefit %s", psr, reason);
			});
	}

	initTracking(container: HTMLElement) {
		const cinema = container.querySelector<HTMLOcCinemaV1Element>("oc-cinema-v1");
		if (!cinema) {
			return log.info("no cinema found in teaser");
		}

		const additionalLabel: DataContainer = { benefit_Slot: ["footer"] };

		/*                                                                                      */
		cinema.addEventListener("tr-submit-tracking", ({ detail }) => {
			switch (true) {
				case detail.eventName === "tr-become-visible" && detail.method === "submitMiniAction":
					addMiniActionsToVisibilityChanges(detail, cinema, "scroll", PARENT_ID);
					break;
				case detail.eventName === "tr-page-impression" && detail.method === "submitMerge":
					/*                                                                                */
					addLoadedTracking(detail, cinema, 1, log as unknown as Debug<string>, PARENT_ID, additionalLabel);
					break;
				default:
					break;
			}
		});
	}
}
